<template>
  <div class="doctorpc-apply-complete">
    <docpc-steps :current="stepActive"></docpc-steps>
    <div class="docpc-panel">
      <div class="form-box">
        <div class="docpc-form-title">注册申请</div>
        <form-panel class="docpc-form" ref="completeForm" :arr="formArr" @change="formChange" @confirm="formConfirm" @onSearch="formSearch"></form-panel>
        <van-form class="from docpc-form-extra" input-align="left">
          <van-field label="手写签名" required>
            <template #input>
              <van-button size="small" @click="goPage('docpcApplySign')">前往签名</van-button>
            </template>         
          </van-field>
          <van-field label="认证材料" required>
            <template #input>
              <van-button size="small" @click="goPage('docpcApplyAttach')">前往上传</van-button>
              <span style="font-size: 12px; margin-left: 10px;">选择材料类型（两类材料二选一）</span>
            </template>         
          </van-field>
        </van-form>
        <div class="agree-box">
          <van-checkbox v-model="checked" :checked-color="themeColor" icon-size="16px">我已同意在“择美同行患者援助项目”医生系统备案进行个人信息采集，并确认以上信息真实有效。</van-checkbox>
        </div>
        <div class="docpc-form-btn">
          <!-- <div class="btn-item">
            <van-button block size="small" :disabled="btnDisabled" @click="goBack()">返回</van-button>
          </div> -->
          <div class="btn-item">
            <van-button v-if="checked" :color="themeColor" block size="small" :disabled="btnDisabled" @click="submit()">提交</van-button>
            <van-button v-else :color="themeColor" disabled block size="small">提交</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@vant/touch-emulator' // 解决vant组件在pc端不支持touch事件
import docpcSteps from "@/doctor_pc/components/steps/steps.vue"
import formPanel from "@/doctor_pc/components/form/form.vue"
import {
  doctorGetDetail,
  papGetHospital,
  getDepartmentJob,
  doctorComplete
} from '@/api/doctorapi';
import { GetDoctorHospital } from '@/api/api'
import {
  Toast,
} from "vant";
import {
  mapState,
  mapActions
} from "vuex";

export default {
  name: 'docpcApplyComplete',
  components: {
    docpcSteps,
    formPanel
  },
  data() {
    return {
      isnew: 0,
      themeColor: this.themeColor,
      stepActive: null,
      btnDisabled: false,
      checked: false,
      doctorInfo: null,
      formArr: [
        {
          type: 'text',
          label: '姓名',
          name: 'name',
          value: '',
          require: 1,
          readonly: 1,
        },
        {
          type: 'text',
          limit: 'tel',
          label: '手机号码',
          name: 'mobile',
          maxlength: 11,
          value: '',
          require: 1,
          readonly: 1,
          hasSmsCode: 0,
        },
        // {
        //   type: 'text',
        //   limit: 'digit',
        //   label: '验证码',
        //   name: 'verifycode',
        //   maxlength: 6,
        //   value: '',
        //   require: 1,
        // },
        {
          type: 'text',
          label: '邮箱',
          name: 'email',
          placeholder: '请输入您的邮箱',
          value: '',
          require: 1,
        },
        {
          type: 'text',
          label: '传真',
          name: 'fax',
          placeholder: '请输入您的传真',
          value: '',
          require: 0,
        },
        {
          type: 'text',
          label: '联系地址',
          name: 'address',
          placeholder: '可接收项目专用章地址',
          value: '',
          require: 1,
        },
        {
          type: 'text',
          label: '邮编',
          name: 'postalcode',
          placeholder: '请输入您的邮编',
          value: '',
          require: 0,
        },
        {
          type: 'text',
          label: '所属医院',
          name: 'hospital',
          placeholder: '请输入所属医院的全称',
          // option: [],
          value: '',
          require: 1,
        },
        {
          type: 'select',
          label: '所属科室',
          name: 'department',
          option: [],
          value: '',
          require: 1,
        },
        {
          type: 'select',
          label: '职称',
          name: 'job',
          option: [],
          value: '',
          require: 1,
        },
      ],
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapActions(['SET_DOCPC_INFO','SET_DOCPC_FORM','CLEAR_DOCPC_FORM']),
    goBack() {
      this.$router.back()
    },
    async getData() {
      let that = this
      await doctorGetDetail({params:{id: this.docpc.docpcInfo.doctor.id}}).then(res => {
        console.log('doctorGetDetail', res.data, 'this.docpc.docpcForm:',this.docpc.docpcForm)
        // if (!res.data.doctor.status && this.$route.query.isNew == 1) {
        //   this.isnew = this.$route.query.isNew
        // }
        this.doctorInfo = res.data.doctor
        let docpcinfo = this.docpc.docpcInfo
        docpcinfo.doctor = res.data.doctor
        docpcinfo.attaches = res.data.attaches
        this.SET_DOCPC_INFO(docpcinfo)

        let formData = null
        if(this.docpc.docpcForm) {
          formData = this.docpc.docpcForm.doctor
        } else {
          let docpcform = {
            doctor: {},
            attaches: {}
          }
          formData = res.data.doctor
          // if (this.isnew == 1) {
          //   formData.email = ''
          //   formData.fax = ''
          //   formData.address = ''
          //   formData.postalcode = ''
          //   formData.hospital = ''
          //   formData.department = ''
          //   formData.job = ''
          //   formData.signature_image = ''
          // } else {
            if (res.data.attaches) {
              for(let i in res.data.attaches) {
                let ele = res.data.attaches[i]
                let value = []
                for (let j in ele) {
                  value.push({
                    id: ele[j].id,
                    src: ele[j].filepath
                  })
                }
                if (i == '执业医生资格证人像页') {
                  docpcform.attaches.headattach = value
                } else if (i == '执业医生资格证身份信息页') {
                  docpcform.attaches.infoattach = value
                } else if (i == '身份证人像面') {
                  docpcform.attaches.idcard_front = value
                } else if (i == '身份证国徽面') {
                  docpcform.attaches.idcard_back = value
                } else if (i == '卫健委网站医生注册信息查询截图') {
                  docpcform.attaches.caram = value
                } else if (i == '医⽣姓名电⼦签名照⽚') {
                  if (ele.length>0 && ele[0].filepath && !formData.signature_image) {
                    formData.signature_image = ele[0].filepath
                  }
                }
              }
            }
          // }
          docpcform.doctor = formData
          this.SET_DOCPC_FORM(docpcform)
        }
        console.log('created',formData)
        if (formData) {
          for(let i in this.formArr) {
            let element = this.formArr[i]
            for(let j in formData) {
              let ele = formData[j]
              if(element.name==j && ele) {
                element.value = ele
              }
            }
          }
        }
      }).catch(err => {
        Toast(err.response.data.message)
      })
      // await papGetHospital().then(res => {
      //   console.log('papGetHospital', res.data)
      //   let arr = []
      //   res.data.forEach(ele => {
      //     arr.push({
      //       value: ele.name
      //     })
      //   });
      //   let obj = {value: this.doctorInfo.hospital}
      //   if (!arr.includes(obj)) {
      //     arr.push(obj)
      //   }
      //   for(let i in this.formArr) {
      //     if(this.formArr[i].name=='hospital') {
      //       this.formArr[i].option = arr
      //     }
      //   }
      // }).catch(err => {
      //     Toast(err.response.data.message)
      // })
      await getDepartmentJob().then(res => {
        console.log('getDepartmentJob', res.data)
        let arr = []
        let jobs = []
        res.data.departments.forEach(ele => {
          arr.push({
            value: ele
          })
        });
        let objd = {value: this.doctorInfo.department}
        if (!arr.includes(objd)) {
          arr.push(objd)
        }
        res.data.jobs.forEach(ele => {
          jobs.push({
            value: ele
          })
        });
        let objj = {value: this.doctorInfo.job}
        if (!jobs.includes(objj)) {
          jobs.push(objj)
        }
        for(let i in this.formArr) {
          if(this.formArr[i].name=='department') {
            this.formArr[i].option = arr
          } else if(this.formArr[i].name=='job') {
            this.formArr[i].option = jobs
          }
        }
      }).catch(err => {
        Toast(err.response.data.message)
      })
    },
    formSearch(val) {
      console.log('formSearch',val ,this.formArr)
      if (val.name == "hospital") {
        GetDoctorHospital({name: val.keyword}).then(res => {
          console.log('GetDoctorHospital', res.data)
          let arr = []
          res.data.forEach(ele => {
            arr.push({
              value: ele.name
            })
          });
          // let obj = {value: this.doctorInfo.hospital}
          // if (!arr.includes(obj)) {
          //   arr.push(obj)
          // }
          for(let i in this.formArr) {
            if(this.formArr[i].name=='hospital') {
              this.formArr[i].option = arr
            }
          }
        }).catch(err => {
            Toast(err.response.data.message)
        })
      }
    },
    formChange(value) {
      let req = {}
      for(let i in value) {
        let ele = value[i]
        req[ele.name] = ele.value
      }
      req.signature_image = this.docpc.docpcForm.doctor.signature_image
      let docpcform = this.docpc.docpcForm
      docpcform.doctor = req
      this.SET_DOCPC_FORM(docpcform)
      console.log('formChange',value ,docpcform)
    },
    formConfirm(value) {
      let req = {}
      for(let i in value) {
        let ele = value[i]
        req[ele.name] = ele.value
      }
      if (this.docpc.docpcForm.doctor.signature_image) {
        req.signature_image = this.docpc.docpcForm.doctor.signature_image
      } else {
        Toast('请完善手写签名')
        return;
      }
      if (this.docpc.docpcForm.hasOwnProperty('attaches')) {
        let obj = this.docpc.docpcForm.attaches
        let b11 = Boolean(obj.hasOwnProperty('headattach') && obj.headattach.length>0)
        let b12 = Boolean(obj.hasOwnProperty('infoattach') && obj.infoattach.length>0)
        let b21 = Boolean(obj.hasOwnProperty('idcard_front') && obj.idcard_front.length>0)
        let b22 = Boolean(obj.hasOwnProperty('idcard_back') && obj.idcard_back.length>0)
        let b23 = Boolean(obj.hasOwnProperty('caram') && obj.caram.length>0)
        if ((b11 && b12) || (b21 && b22 && b23)) {
          req.attaches = {}
          for (let a in this.docpc.docpcForm.attaches) {
            let elea = this.docpc.docpcForm.attaches[a]
            let arr = []
            for (let b in elea) {
              let eleb = elea[b]
              if (eleb.is_New) {
                arr.push(eleb)
              }
            }
            req.attaches[a] = arr
          }
        } else {
          Toast('请上传认证材料')
          return
        }
      } else {
        Toast('请上传认证材料')
        return
      }
      req.id = this.docpc.docpcInfo.doctor.id
      console.log('formConfirm',value, req)
      this.btnDisabled = true
      doctorComplete(req).then(res => {
        console.log('doctorComplete', res.data)
        this.btnDisabled = false
        this.CLEAR_DOCPC_FORM()
        let docpcinfo = this.docpc.docpcInfo
        docpcinfo.doctor = res.data
        this.SET_DOCPC_INFO(docpcinfo)
        this.$router.replace({
          name: "docpcMsg",
        });
      }).catch(err => {
        this.btnDisabled = false
        Toast(err.response.data.message)
      })
    },
    submit() {
      this.$refs.completeForm.next()
    },
    goPage(name) {
      this.$refs.completeForm.change()
      this.$nextTick(()=>{
        this.$router.push({
          name: name,
          query: {
            isNew: this.isnew
          }
        });
      })
    },
  }
}
</script>

<style lang='less'>
.doctorpc-apply-complete {
  .docpc-form {
    .from { margin-bottom: 0;}
    .van-cell {
      padding: 6px 16px;
    }
    .van-field__label {
      text-align: right;
    }
    .van-cell--required {
      &::before { display: none; }
      .van-field__label {
        &::before {
          color: #ee0a24; font-size: 14px; content: '*';
        }
      }
    }
  }
  .docpc-form-extra {
    .van-cell {
      background-color: transparent; padding: 6px 16px;
      &::after {
        display: none;
      }
    }
    .van-field__label {
      margin-top: 5px; text-align: right;
    }
    .van-field__value {
      padding: 2px 0;
    }
    .van-cell--required {
      &::before { display: none; }
      .van-field__label {
        &::before {
          color: #ee0a24; font-size: 14px; content: '*'; margin-top: 5px;
        }
      }
    }
  }
  .agree-box {
    height: 60px;
    line-height: 20px;
    padding: 20px;
    text-align: center !important;
    vertical-align: middle;
    .van-checkbox {
      justify-content: center;
    }
  }
  .docpc-picker-bottom {
    width: 500px;
    .docpc-picker-close {
      color: #bbb; cursor: pointer; z-index: 1; position: absolute; top: 16px; right: 16px;
    }
    .van-search {
      margin-right: 40px;
      .van-cell {
        padding: 5px;
      }
      .search-btn {
        color: #fff; background: @docpc-color; height: 34px; padding: 0 8px; font-size: 12px; display: inline-block; text-align: center; border-radius: 2px; cursor: pointer; transition: opacity .2s;
        &:active {
          opacity: .8;
        }
      }
    }
    .van-picker__toolbar {
      justify-content: center; height: 64px;
      .van-picker__cancel,.van-picker__confirm {
        min-width: 90px; border: #ccc solid 1px; font-size: 13px; height: 32px; margin: 0 10px; border-radius: 2px;
      }
      .van-picker__cancel {
        color: #666;
      }
      .van-picker__confirm {
        border-color: @docpc-color; background: @docpc-color; color: #fff;
      }
    }
  }
}
</style>